import * as L from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import { MarkerClusterGroup } from "leaflet.markercluster/src";

var locationsJSON = [

  {
    name    : 'London',
    address : '<strong>Wafra Europe Limited</strong><br>27 Knightsbridge<br>London SW1X 7LY',
    phone   : '<strong>P. +44 (0) 203.095.5800</strong>',
    image   : '/wp-content/themes/wafra/dist/images/locations/london.jpg',
    type    : 'office',
    lat     : 51.5022252,
    lng     : -0.1552383
  },
  {
    name    : 'Bermuda',
    address : '<strong>Wafra Financial & Management Services Ltd.</strong><br>Ideation House, 94 Pitts Bay Road, 1st Floor, Pembroke HM 08, Bermuda',
    phone   : '<strong>P. +1 441.405.3700</strong>',
    image   : '/wp-content/themes/wafra/dist/images/locations/bermuda.jpg',
    type    : 'office',
    lat     : 32.298590,
    lng     : -64.786930
  },
  {
    name    : 'New York',
    address : '<strong>Wafra Inc.</strong><br>345 Park Avenue, 41st Floor<br>New York, NY 10154-0101',
    phone   : '<strong>P. +1 212.759.3700</strong>',
    image   : '/wp-content/themes/wafra/dist/images/locations/new-york.jpg',
    type    : 'headquarters',
    lat     : 40.757720,
    lng     : -73.972350
  }

];

$(document).ready(function() {

  if ( $('#locations--map').length > 0 ) {

    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    var mapboxAccessToken = 'pk.eyJ1Ijoiam9zaHVhYWRyaWFuIiwiYSI6ImNrcWg3M3RncjE3azMyb251YmtjY3gyZWUifQ.kB3LT17nV87JvvwSJvFIIg';

    var mymap = L.map( 'locations--map', {
      gestureHandling: true
    })
    .setView([36, -24], 2);

    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoiam9zaHVhYWRyaWFuIiwiYSI6ImNrcWg3M3RncjE3azMyb251YmtjY3gyZWUifQ.kB3LT17nV87JvvwSJvFIIg', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 2,
      minZoom : 2,
      id: 'joshuaadrian/clkn72abb01c201qm0obm5b9r',
      //id: mapJSON.mapboxStyles,
      tileSize: 512,
      zoomOffset: -1,
      accessToken: mapboxAccessToken
    }).addTo(mymap);

    var markers = new MarkerClusterGroup();

    function setMarkers() {

      var blueIcon = L.icon({
        iconUrl: '/wp-content/themes/wafra/dist/images/icon-office.svg',
        shadowUrl: '',
        iconSize:     [30, 30], // size of the icon
        shadowSize:   [24, 21], // size of the shadow
        iconAnchor:   [15,15], // point of the icon which will correspond to marker's location
        shadowAnchor: [-10, -18],  // the same for the shadow
        popupAnchor:  [180, 300] // point from which the popup should open relative to the iconAnchor
      });

      var yellowIcon = L.icon({
        iconUrl: '/wp-content/themes/wafra/dist/images/icon-headquarters.svg',
        shadowUrl: '',
        iconSize:     [30, 30], // size of the icon
        shadowSize:   [24, 21], // size of the shadow
        iconAnchor:   [15,15], // point of the icon which will correspond to marker's location
        shadowAnchor: [-10, -18],  // the same for the shadow
        popupAnchor:  [180, 300] // point from which the popup should open relative to the iconAnchor
      });

      for (let myLocations = 0; myLocations < locationsJSON.length; myLocations++) {

        // console.log('-------');
        // console.log(locationsJSON[myLocations]);
        // console.log('-------');

        var iconType = locationsJSON[myLocations].type.indexOf('headquarters') != -1 ? yellowIcon : blueIcon;

        if (
          typeof locationsJSON[myLocations].lat !== "undefined"
          && typeof locationsJSON[myLocations].lng !== "undefined"
        ) {

          //console.log(locationsJSON[myLocations].lat);

          var latLng = [locationsJSON[myLocations].lat, locationsJSON[myLocations].lng];
          var popupContent = '<div class="locations--popup"><div class="locations--popup--image" style="background-image:url('+locationsJSON[myLocations].image+')"></div><h3>'+ locationsJSON[myLocations].name + '</h3><p>'+locationsJSON[myLocations].address + '<br>' + locationsJSON[myLocations].phone + '</p></div>';
          //markers.addLayer(L.marker(latLng,{icon: iconType}).bindPopup(popupContent));

          var marker = L.marker(latLng,{icon: iconType}).bindPopup(popupContent).addTo(mymap);

        }

      }

      //mymap.addLayer(markers);

    }

    setMarkers();

  };

});
